import { SizehtMatrixEntity } from "../../po-bom/entittes/size-ht-matrix-entity";
import { SIzeMatrixFabricBDto } from "../dto/size-matrix-dto";

export class SizeMatrixAdapter {
    public convertDtoToEntity(dto: SIzeMatrixFabricBDto): SizehtMatrixEntity {
        const entity = new SizehtMatrixEntity()
        entity.id = dto.id;
        entity.style = dto.style;
        entity.imCode = dto.imCode;
        entity.fit = dto.fit; 
        entity.htColor = dto.htColor;
        entity.fabricCode = dto.fabricCode;
        entity.fabricContent = dto.fabricContent;
        entity.fabricCombinations = dto.fabricCombinations;
       
        if (dto.id) {
            entity.id = dto.id;
            entity.updatedUser = dto.createdUser;
        } else {
            entity.createdUser = dto.createdUser;
        }
        return entity
    }


    public convertEntityToDto(entity: SizehtMatrixEntity): SIzeMatrixFabricBDto {

        const dto = new SIzeMatrixFabricBDto()
        dto.id = entity.id;
        dto.style = entity.style;
        dto.imCode = entity.imCode;
        dto.fit = entity.fit;
        dto.htColor = entity.htColor
        dto.createdAt = entity.createdAt
        dto.updatedAt = entity.updatedAt
        dto.updatedUser = entity.updatedUser
        dto.isActive = entity.isActive;
        dto.versionFlag = entity.versionFlag;
        dto.fabricCode = entity.fabricCode;
        dto.fabricContent = entity.fabricContent;
        dto.fabricCombinations = entity.fabricCombinations;
       
        return dto
    }

}